import React from "react";
import { Tile, BigNum } from "./primitives";

export default function CommunityPanel({ scenariosSaved }) {
  return (
    <Tile title="Community" testid="tile-community">
      <BigNum
        label="Scenarios saved to server"
        value={scenariosSaved || 0}
        testid="scenarios-count"
      />
      <div className="text-xs text-[#5C6B62] mt-4 leading-relaxed">
        Most plans live in the user&apos;s browser (localStorage). This count reflects
        explicit &quot;save to server&quot; actions.
      </div>
    </Tile>
  );
}
